
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const initializeVideoButton = (container) => {
    const button = container.querySelector('.testimonials-carousel-play-button');
    const embedContainer = container.querySelector('.embed-video-container');

    if(!button || button._initialized) return;

    const stopVideo = () => {
      if(container.querySelector('video')){
        container.querySelector('video').pause();
        container.querySelector('video').currentTime = 0;
        if(button){
          button.classList.remove('hidden');
        }
      }else if(embedContainer.placeholderContent){
        embedContainer.innerHTML = embedContainer.placeholderContent;
        if(button){
          button.classList.remove('hidden');
        }
      }
    }

    container.stopVideo = stopVideo;

    button.addEventListener('click', (event) => {
      event.preventDefault();

      if(container.querySelector('video')){
        container.querySelector('video').play();
        button.classList.add('hidden');
      }else if(container.querySelector('.embed-video-container')?.dataset.source === 'youtube') {
        let video = '';
        video = '<iframe src="https://www.youtube.com/embed/';
        video += embedContainer.dataset.videoId + '?autoplay=1';
        video += '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" loading="lazy"></iframe>';
        
        embedContainer.placeholderContent = embedContainer.innerHTML;
        embedContainer.innerHTML = video;
        button.classList.add('hidden');
      }else if(container.querySelector('.embed-video-container')?.dataset.source === 'vimeo') {
        let video = '';
        video = '<iframe src="https://player.vimeo.com/video/';
        video += embedContainer.dataset.videoId;
        video += '?autoplay=1&byline=0&portrait=0&badge=0&dnt=true&vimeo_logo=false&title=false&color=FB4400';
        video += '"allow="autoplay; fullscreen; picture-in-picture" loading="lazy"></iframe>';

        embedContainer.placeholderContent = embedContainer.innerHTML;
        embedContainer.innerHTML = video;
        button.classList.add('hidden');
      }
    });

    button._initialized = true;
  }

  document.querySelectorAll('.testimonials-carousel-video-container').forEach(initializeVideoButton);

  document.querySelectorAll('.testimonials-carousel-swiper').forEach((element) => {
    const getConfiguredValueForWidth = (swiper, paramName) => {
      const width = window.innerWidth;
      let value = swiper.passedParams[paramName];
      let matched = 0;
      const breakpoints = swiper.passedParams.breakpoints || {};
      Object.keys(breakpoints).forEach(bp => {
        const bpNum = parseInt(bp, 10);
        if (width >= bpNum && bpNum > matched) {
          matched = bpNum;
          if (breakpoints[bp][paramName] !== undefined) {
            value = breakpoints[bp][paramName];
          }
        }
      });
      return value;
    }

    const swiperItemsCalc = (swiper) => {
      const container = swiper.el.closest('section');
      const containerGap = parseInt(getComputedStyle(container).getPropertyValue('column-gap'));
      const swiperWidth = (container.offsetWidth - containerGap) / 2; 
      const correctWidth = swiper.el.parentNode.querySelector('.swiper-controls, .swiper-sizer')?.offsetWidth;
      const items = getConfiguredValueForWidth(swiper, 'slidesPerView');
      const itemWidth = correctWidth / items;
      const loop = getConfiguredValueForWidth(swiper, 'loop');
      const slides = Math.floor(swiperWidth / itemWidth) + (loop ? 1 : 0);
      const newSwiperWidth = slides * itemWidth;
      swiper.el.style.width = newSwiperWidth + 'px';
      swiper.params.slidesPerView = slides;
      swiper.update();
      return slides;
    }

    const cloneSlides = (swiper, visibleSlides = 10) => {
      const wrapper = swiper.el.querySelector('.swiper-wrapper');
      const slides = Array.from(wrapper.children);
      
      if (slides.length > visibleSlides) return;

      const minimumQuantityToClone = visibleSlides - slides.length;
      let cloneCount = 0;

      do{
        for (let i = 0; i < slides.length; i++) {
          const clone = slides[i].cloneNode(true);
          clone.classList.add('swiper-slide-duplicate');
          wrapper.appendChild(clone);
          cloneCount++;
        }
      }while(cloneCount < minimumQuantityToClone);

      wrapper.querySelectorAll('.testimonials-carousel-video-container').forEach(initializeVideoButton);
    }

    new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: 1,
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 1,
        },
        1168: {
          slidesPerView: 2,
        },
      },
      spaceBetween: 32,
      simulateTouch: false,
      navigation: {
        enabled: element.dataset.navigation == '1',
        prevEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .prev'),
        nextEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .next'),
      },
      pagination: {
        enabled: element.dataset.pagination == '1',
        el: element.closest('.swiper-parent').querySelector('.swiper-pagination'),
        clickable: true,
      },
      loop: element.dataset.loop == '1',
      clonedSlides: 10,
      autoplay: element.dataset.autoplay == '1'
        ? {
            delay: parseFloat(element.dataset.autoplayDelay) * 1000,
          }
        : false,
      on: {
        beforeInit: (swiper) => {
          if(element.dataset.loop == '1'){
            const visibleSlides = swiperItemsCalc(swiper);
            cloneSlides(swiper, visibleSlides);
          }
        },
        resize: swiperItemsCalc,
        slideChangeTransitionEnd: (swiper) => {
          swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .testimonials-carousel-video-container').forEach((videoContainer) => {
            videoContainer?.stopVideo();
          });
        }
      }
    });
  });
});
